<ng-container *ngIf="items$ | async as items">
  <div
    *ngFor="let toast of items; trackBy: trackById"
    class="tt-toast"
    [class.tt-toast--success]="toast.variant === 'success'"
    [class.tt-toast--error]="toast.variant === 'error'"
    [class.tt-toast--info]="toast.variant === 'info'"
    [class.tt-toast--enter]="!toast.leaving"
    [class.tt-toast--leave]="toast.leaving"
    [attr.role]="toast.variant === 'error' ? 'alert' : 'status'"
    [attr.aria-live]="toast.variant === 'error' ? 'assertive' : 'polite'">
    <span class="tt-toast__icon" aria-hidden="true">
      <svg *ngIf="toast.variant === 'success'" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
      </svg>
      <svg *ngIf="toast.variant === 'error'" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
      </svg>
      <svg *ngIf="toast.variant === 'info'" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
      </svg>
    </span>
    <p class="tt-toast__message">{{ toast.message }}</p>
    <button type="button" class="tt-toast__close" (click)="dismiss(toast.id)" aria-label="Zavřít">
      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
      </svg>
    </button>
  </div>
</ng-container>
